
<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-bar" style="text-align: left;padding:1vh;">
        <!-- <el-select
          v-model="proSel"
          clearable
          placeholder="请选择"
          @change="proChange"
          style="margin-left:20px;"
        >
          <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->
        <span>序列号：</span>
        <el-input placeholder="请输入设备序列号" v-model="imei"></el-input>
        <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
        <el-button type="primary" class="add-user" @click="addRow()" style="margin-left:2vw;">配置GPS设备</el-button>
      </div>
      <div class="build-table">
        <el-table
          :default-sort="{prop: 'date', order: 'descending'}"
          :data="tableDataEnd"
          style="width: 100%;"
          border
          height="100%"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80" type="index">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Sn号">
            <template slot-scope="scope">
              <a>{{ scope.row.sn }}</a>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type=='1'">GPS</span>
              <span v-else-if="scope.row.type=='2'">GPS+VF</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label="所属项目">
            <template slot-scope="scope">
              <span>{{ scope.row.projectName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="在线时间">
            <template slot-scope="scope">
              <span>{{ scope.row.updateDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>

          <!-- 新增窗口 -->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="500px"
          >
            <el-form
              :model="addForm"
              ref="addForm"
              label-width="100px"
              :label-position="labelPosition"
            >
              <!-- <el-form-item label="所属项目：" prop="field">
                <el-select v-model="addForm.projectId" clearable filterable placeholder="请选择">
                  <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="设备SN：">
                <el-input v-model="addForm.imei" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-select v-model="addForm.type" placeholder="请选择">
                  <el-option
                    v-for="item in typesAll"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="厂家：">
                <el-select v-model="addForm.machType" placeholder="请选择">
                  <el-option
                    v-for="item in machTypes"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="位置:">
                <el-input type="textarea" v-model="addForm.locationDesc"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
            </div>
          </el-dialog>
        </el-table>

        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
var _index
export default {
  data() {
    return {
      labelPosition: 'right',
      // addLoading: false,
      proSel: '',
      imei: '', //序列号
      addForm: {
        id: '',
        projectId: '',
        imei: '',
        status: '',
        machType: '',
        locationDesc: '',
        type:''
      },
      typesAll:[{name:'gps',value:'1'},{name:'gps+vh',value:'2'},],
      addFormVisible: false,
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      flag: false,
      projects: [], //项目列表 - 下拉选择
      dialogTitle: '', //弹出框标题
      types: [],
      machTypes: [
        //设备厂家
        { name: '零视1', value: '1' },
        { name: '汉王', value: '2' },
        { name: '宇泛', value: '3' },
        { name: '零视2', value: '4' },
      ],
      dataText: '数据加载中...'
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    // this.groupName = ''
    // this.getProjects()
    this.getData()
    // this.getDict()
  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    //获取项目
    getProjects() {
      var that = this
      myHttp
        .getProjectById({
          id:this.groupId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = [resp.data.data.project]
              // that.groupName = resp.data.data.project.name
              that.projects = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //监听分页一页展示数量改变
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    //监听当前页面改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      myHttp.getAllGpsEquip({
          projectId: this.groupId,
          sn:this.imei,
          pageSize:this.pageSize,
          pageNum:this.currentPage
      }).then(function(resp) {
        console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.gpsList.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // list[i].projectName = list[i].projectName && list[i].projectName!=''?list[i].projectName:
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.gpsList.total || 0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '设备修改'
      this.addFormVisible = true
      this.addForm = {
        id: row.id,
        projectId: row.projectId,
        imei: row.sn,
        status: row.status,
        // machType: row.machType,
        // locationDesc: row.locationDesc
      }
    },
    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .deleteGpsBySn({
              sn: row.sn,
              projectId:row.projectId
            })
            .then(function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增数据
    addRow() {
      this.dialogTitle = '安全帽绑定'
      ;(this.addFormVisible = true),
        (this.addForm = {
          id:'',
          projectId: '',
          imei: '',
          status: '',
          machType: ''
        })
    },
    // 将新增的数据添加到表格中
    sumbitAddRow() {
      var that = this
      this.addForm.projectId = this.groupId
      this.addForm.projectName = this.getNameById(this.addForm.projectId)
      this.addForm.sn = this.addForm.imei
      if (!this.addForm.id || this.addForm.id == '') {
        // this.addForm.id = this.addForm.imei
        myHttp.createGps(this.addForm).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('绑定成功')
            that.addFormVisible = false
            that.currentPage = 1
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        myHttp.updateGpsData(this.addForm).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('绑定成功')
            that.addFormVisible = false
            that.currentPage = 1
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }
      
      
    },
    //根据id过滤出name
    getNameById(id) {
      var result = ''
      for (var i = 0; i < this.projects.length; i++) {
        if (id == this.projects[i].id) {
          result = this.projects[i].name
        }
      }
      return result
    },
    cancel() {
      this.addFormVisible = false
    },
    //监听下拉框改变
    proChange() {
      this.getData()
    },
    // 字典接口
    // getPageList
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.types = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    }
  }
}
</script>

<style>
@import '../../../assets/css/common.css';
</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  height: calc(100% - 100px);
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.build-table >>> .el-dialog {
  padding-left: 0;
}
</style>
<style>
.el-select .el-input {
  width: 100%;
}
</style>